module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h2 class="logo"><a href="http://colido.de" target="_blank">Colido</a></h2>\n<div class="signup-region container active"></div>\n<div class="signup-token-region container"></div>\n<div class="login-region container "></div>\n<div class="forgot-password-region container"></div>\n<div class="forgot-password-token-region container"></div>\n<div class="delete-account-region container"></div>';
}
return __p;
};